// Tier (점) badges. One icon per band — stone / jewel / crown — with the 점 number
// carrying the detail within a band.
//   30, 50, 80, 100        → 🪨 stone
//   120, 150, 200, 250     → 💎 jewel
//   300, 400, 500          → 👑 crown
export function tierBadge(tier: number): string {
  if (tier >= 300) return '👑';
  if (tier >= 120) return '💎';
  return '🪨';
}

/** "🪨 30점" — badge + tier number, the standard inline label. */
export function tierLabel(tier: number): string {
  return `${tierBadge(tier)} ${tier}점`;
}

/** The full 점 ladder, low to high — mirrors server/ranking.mjs's TIERS. */
export const TIERS = [30, 50, 80, 100, 120, 150, 200, 250, 300, 400, 500];

/** How many ladder steps apart two tiers are (0 = same tier). Nearest-rung
 *  snapping mirrors the server so a stray value can't under/over-count. */
export function tierStepsApart(a: number, b: number): number {
  const nearest = (t: number) => TIERS.reduce((best, x) => (Math.abs(x - t) < Math.abs(best - t) ? x : best), TIERS[0]);
  return Math.abs(TIERS.indexOf(nearest(a)) - TIERS.indexOf(nearest(b)));
}
